export const GET_ROLES_OLD = 'GET_ROLES_OLD';
export const GET_ROLES_SUCCESS_OLD = 'GET_ROLES_SUCCESS_OLD';
export const GET_ROLES_ERROR_OLD = 'GET_ROLES_ERROR_OLD';
